import Cookies from "js-cookie";
import React, { useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

export default function CustomLeftBar({ page = "", subPage = "" }) {
  const [cookies, setCookie, removeCookie] = useCookies(['TokenAdmin']);
  const [show, setshow] = useState(true);
  const menu = [
    {
      title: "Dashboard",
      logo: "/img/menu-dashboard.png",
      link: "/admin/home",
      subtitle: [],
    },
    {
      title: "Posts",
      logo: "/img/menu-post.png",
      link: "/admin/post",
      subtitle: [
        { name: "Add New Post", link: "/admin/post/add" },
        { name: "News & Event", link: "/admin/post" },
        { name: "Khowledge", link: "/admin/post/knowledge" },
      ],
    },
    {
      title: "Products",
      logo: "/img/menu-product.png",
      link: "/admin/products",
      subtitle: [
        { name: "Add New Products", link: "/admin/products/add" },
        { name: "Circular Design", link: "/admin/products" },
      ],
    },
  ];
  const router = useNavigate();
  return (
    <div
      className={
        (show ? "w-[250px] bg-[#1D2327] h-full " : "") + "fixed sm:relative"
      }
    >
      <div
        onClick={() => {
          setshow(!show);
        }}
        className="sm:hidden p-2 bg-white drop-shadow-lg rounded-r-lg absolute cursor-pointer font_Kanit"
      >
        Menu
      </div>
      <div className="h-[50px] sm:hidden" />
      {show
        ? menu.map((item, i) => {
            return (
              <div key={i}>
                <div
                  onClick={() => {
                    router(item.link);
                  }}
                  className={
                    "flex flex-row gap-2 items-center font_Kanit text-base text-white py-3 px-8 cursor-pointer active:opacity-50 hover:opacity-80 " +
                    (item.title == page ? "font-semibold bg-[#2271B1]" : "")
                  }
                >
                  <img src={item.logo} className="w-6 h-6 object-contain" />
                  <p>{item.title}</p>
                </div>
                {item.title == page
                  ? item.subtitle.map((subItem, j) => {
                      return (
                        <div
                          key={j}
                          onClick={() => {
                            router(subItem.link);
                          }}
                          className={
                            "font_Kanit  text-base text-white py-3 px-8 cursor-pointer active:opacity-50 hover:opacity-80 bg-[#2C3338] " +
                            (subItem.name == subPage ? "font-semibold " : "")
                          }
                        >
                          {subItem.name}
                        </div>
                      );
                    })
                  : null}
              </div>
            );
          })
        : null}
      <div
        onClick={() => {
          Cookies.remove('TokenAdmin')
          router("/admin");
        }}
        className="self-end flex flex-row gap-2 items-center font_Kanit text-base text-white py-3 px-8 cursor-pointer active:opacity-50 hover:opacity-80"
      >
        ออกจากระบบ
      </div>
    </div>
  );
}
